export default "__VITE_ASSET__CZCTltzi__"